import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { useIsMobileWithBreakpoint } from 'hooks/useIsMobileWithBreakpoint';

import DesktopControls from './components/DesktopControls';
import MobileControls from './components/MobileControls';

const Filters = ({
	urlParams,
	defaultUrlParams,
	filtersValues,
	handleFilterChange,
	handleFilterReset,
	showSortFilter = true,
	rubricPath
}) => {
	const isMobile = useIsMobileWithBreakpoint('tabletMedium');

	const filters = {
		..._(urlParams).omit('page', 'limit')
	};

	return isMobile ? (
		<>
			<MobileControls
				defaultFiltersValues={defaultUrlParams}
				onFilterChange={handleFilterChange}
				onFilterReset={handleFilterReset}
				{...{ filtersValues, filters, showSortFilter, rubricPath }}
			/>
		</>
	) : (
		<DesktopControls
			defaultFiltersValues={defaultUrlParams}
			onFilterChange={handleFilterChange}
			onFilterReset={handleFilterReset}
			{...{ filtersValues, filters, showSortFilter, rubricPath }}
		/>
	);
};

Filters.propTypes = {
	urlParams: PropTypes.object.isRequired,
	defaultUrlParams: PropTypes.shape({
		location: PropTypes.string
	}),
	rootRubricPath: PropTypes.string,
	filtersValues: PropTypes.shape({
		locales: PropTypes.array,
		currentLocale: PropTypes.shape({
			title: PropTypes.string,
			name: PropTypes.string
		})
	}),
	handleFilterChange: PropTypes.func,
	handleFilterReset: PropTypes.func,
	showSortFilter: PropTypes.bool,
	rubricPath: PropTypes.string
};

export default Filters;
